import { motion } from "framer-motion";

export const Btn = ({ children, variant = "gold", className = "", ...p }) => {
  const base = "inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 text-sm font-semibold tracking-wide transition-[transform,background-color,opacity] active:scale-[0.98] disabled:opacity-40 disabled:pointer-events-none";
  const v = {
    gold: "bg-[#E5B13A] text-[#15120A] hover:bg-[#F5D27A]",
    ghost: "border border-[#2E2E34] text-[#F4EFE6] hover:border-[#E5B13A]/60 hover:bg-white/[0.03]",
    dark: "bg-[#1C1C20] text-[#F4EFE6] hover:bg-[#232328]",
    wa: "bg-[#25D366] text-[#07130B] hover:bg-[#3ee07a]",
  }[variant];
  return (
    <button className={`${base} ${v} ${className}`} {...p}>
      {children}
    </button>
  );
};

export const Card = ({ children, className = "", ...p }) => (
  <div className={`rounded-3xl border border-[#26262B] bg-[#141417] p-5 ${className}`} {...p}>
    {children}
  </div>
);

export const Pill = ({ children, tone = "gold", className = "", ...p }) => {
  const t = {
    gold: "bg-[#E5B13A]/15 text-[#F5D27A] border-[#E5B13A]/30",
    muted: "bg-white/[0.04] text-[#9A948A] border-[#2E2E34]",
    green: "bg-[#25D366]/15 text-[#7ee6a4] border-[#25D366]/30",
    red: "bg-[#E5484D]/15 text-[#ff9a9e] border-[#E5484D]/30",
    blue: "bg-[#5B8DEF]/15 text-[#9dbcff] border-[#5B8DEF]/30",
  }[tone];
  return <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-[0.68rem] font-semibold uppercase tracking-[0.14em] ${t} ${className}`} {...p}>{children}</span>;
};

export const ScoreRing = ({ value = 0, size = 168, label = "Indice benessere", testId = "score-ring" }) => {
  const r = (size - 14) / 2;
  const c = 2 * Math.PI * r;
  const v = Math.max(0, Math.min(100, value));
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid={testId}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="#232328" strokeWidth="10" fill="none" />
        <motion.circle cx={size / 2} cy={size / 2} r={r} stroke="#E5B13A" strokeWidth="10" fill="none" strokeLinecap="round"
          strokeDasharray={c} initial={{ strokeDashoffset: c }} animate={{ strokeDashoffset: c - (c * v) / 100 }} transition={{ duration: 1.2, ease: "easeOut" }} />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-club-display text-5xl font-semibold text-[#F4EFE6] leading-none" data-testid="score-value">{v}</span>
        <span className="mt-1 text-[0.62rem] uppercase tracking-[0.22em] text-[#9A948A]">{label}</span>
      </div>
    </div>
  );
};

export const Bar = ({ label, value, max = 10 }) => (
  <div className="flex items-center gap-3" data-testid={`area-bar-${label.toLowerCase()}`}>
    <span className="w-28 text-xs text-[#9A948A]">{label}</span>
    <div className="h-2 flex-1 rounded-full bg-[#232328] overflow-hidden">
      <motion.div className="h-full rounded-full bg-[#E5B13A]" initial={{ width: 0 }} animate={{ width: `${(value / max) * 100}%` }} transition={{ duration: 0.9 }} />
    </div>
    <span className="w-8 text-right text-xs font-semibold text-[#F4EFE6]">{value}/{max}</span>
  </div>
);

export const Field = ({ label, hint, children }) => (
  <label className="block">
    <span className="mb-1.5 block text-[0.7rem] uppercase tracking-[0.18em] text-[#9A948A]">{label}</span>
    {children}
    {hint && <span className="mt-1 block text-xs text-[#6F6A62]">{hint}</span>}
  </label>
);

export const inputCls = "w-full rounded-2xl border border-[#2E2E34] bg-[#0E0E10] px-4 py-3 text-[#F4EFE6] placeholder:text-[#5E5952] outline-none focus:border-[#E5B13A]/70 transition-colors";

export const Logo = ({ size = 36 }) => (
  <img src="/club/icon-192.png" alt="Diamond Club" width={size} height={size} className="rounded-xl" />
);

export const Footer = () => (
  <p className="px-6 pb-8 pt-10 text-center text-[0.65rem] leading-relaxed text-[#5E5952]">
    Diamond Club è un team indipendente di Forever Living Products. I prodotti indicati sono integratori alimentari e cosmetici: non sostituiscono una dieta variata né il parere del medico.
  </p>
);
